/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'

export type TradeInSearchApiProps = {
  technicalName?: Maybe<string>
  label?: Maybe<string>
  ctaLink?: Maybe<CTALink>
  helperText?: Maybe<string>
}

export const TradeInSearchSchema = z.object({
  technicalName: z.nullish(z.string()),
  label: z.nullish(z.string()),
  ctaLink: z.nullish(CTALinkSchema),
  helperText: z.nullish(z.string()),
})

// Schema validation
type TestTradeInSearchProps = ExpectTrue<
  Equal<TradeInSearchApiProps, z.infer<typeof TradeInSearchSchema>>
>
